/*
 * � 2020 Microsoft. All rights reserved.
 */

define ('util/list',['lodash'], function (_) {

    var List = function () {
        this.initList();
    };

    List.prototype.initList = function () {
        this.items = [];
    };

    List.prototype.add = function (item) {
        if (this.items.indexOf(item) == -1) {
            this.items.push(item);
        }
    };

    List.prototype.remove = function (item) {
        var index = this.items.indexOf(item);
        if (index != -1) {
            this.items.splice(index, 1);
        }
    };

    List.prototype.clear = function () {
        this.items = [];
    };

    List.prototype.applyAll = function (vistor) {
        if (typeof visitor == 'function') {
            _.forEach(this.items, function (item) {
                visitor(item);
            });
        }
    };

    return List;

});
